import packageInfo from '../../package.json';

export const environment = {
    production: true,
    serverUrl: '',
    wsUrl: '',
    version: packageInfo.version,
};
